import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';
gsap.registerPlugin( ScrollTrigger );

( function( app ) {
  const COMPONENT = {
    init: function() {
      const component = document.querySelector( '[data-component="book-now-cta"]' );
      if ( !component ) return;

      const mm = gsap.matchMedia();

      mm.add( '(min-width: 1024px)', () => {
        const images = component.querySelectorAll( 'img' );

        images.forEach( ( img, index ) => {
          const parallaxAmount = 20 + ( index * 10 );
          gsap.to( img, {
            yPercent: parallaxAmount,
            ease: 'none',
            scrollTrigger: {
              trigger: img,
              start: 'top bottom',
              end: 'bottom top',
              scrub: 1,
            },
          } );
        } );
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'book-now-cta', COMPONENT );
} )( app );
